import ExcelJS from "exceljs";
import { formatDateTimeWithoutSec } from "../../../Common/helper/helpar";
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import TippingFeeStore from "./store/TippingFeeStore";
export const ExportTippingFeeData = () => {
  const { fetchTippingFee, tippingFeeData, addTippingFeeData, loading, fetchTippingFeeForMT, tippingFeeDataForMT } = TippingFeeStore()

  const downloadExcel = async () => {
    const { FromDateTime, ToDateTime } = JSON.parse(localStorage.getItem("sat-trips-zone-filters")) || {};

    // Get current date/time for header
    const currentDate = new Date();
    const formattedDate = `${currentDate.getDate()}-${currentDate.getMonth() + 1}-${currentDate.getFullYear()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const filterDateRange =
      FromDateTime && ToDateTime ? `(${formatDateTimeWithoutSec(FromDateTime)} to ${formatDateTimeWithoutSec(ToDateTime)})` : "";

    const reportTitle = `Tipping Fee`;
    const generatedText = `Report Generated on: ${formattedDate}, ${formattedTime}`;

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Zone");

    const boldFont = { bold: true };
    const centerAlignment = { horizontal: "center", vertical: "middle", wrapText: true };

    // --- Header Row 1: Report Generated Text ---
    const headerRow1 = worksheet.addRow([generatedText]);
    worksheet.mergeCells(`A${headerRow1.number}:J${headerRow1.number}`); // Merge across all 10 columns (A to J)
    headerRow1.getCell(1).font = boldFont;
    headerRow1.getCell(1).alignment = centerAlignment;

    // --- Header Row 2: Report Title ---
    const headerRow2 = worksheet.addRow([reportTitle]);
    worksheet.mergeCells(`A${headerRow2.number}:J${headerRow2.number}`); // Merge across all 10 columns (A to J)
    headerRow2.getCell(1).font = boldFont;
    headerRow2.getCell(1).alignment = centerAlignment;

    // --- Table Header Row ---
    const tableHeaderRow = worksheet.addRow([
      "S.No",
      "Owner Type",
      "Collection Type",
      "Tipping Fee Percentage",
      "Per MT In INR",
      "Effective From Date",
      "Previous Tipping Fee",
      "Effective From Date (Previous)",
      "Effective To Date (Previous)",
      "Status",
    ]);
    tableHeaderRow.eachCell((cell) => {
      cell.font = boldFont;
      cell.alignment = centerAlignment;
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "F6B1B1" },
      };
    });

    // --- Data Rows ---
    let totalFeedbackRating = 0;
    tippingFeeData.forEach((item, index) => {
      if (item.isActive) {
        totalFeedbackRating += item.feedBackRating; // Only add active feedback ratings
      }

      const row = worksheet.addRow([
        index + 1,
        item.ownerTypeName || "N/A",
        item.collectionTypeName || "N/A",
        item.tippingFeePercentage || "N/A",
        item.perMtinR || "N/A",
        item.effectiveFromDate || "N/A",
        item.previousTippingFee || "N/A",
        item.previousEffectiveFromDate || "N/A",
        item.previousEffectiveToDate || "N/A",
        item.status ? "Active" : "InActive",
      ]);
      row.eachCell((cell) => {
        cell.alignment = centerAlignment;
      });
    });

    // --- Total Feedback Rating Row ---
    // (Note: This section seems incomplete in your code; adjust as needed)

    // --- Adjust Column Widths ---
    worksheet.columns = [
      { width: 10 },
      { width: 20 },
      { width: 25 },
      { width: 25 },
      { width: 25 },
      { width: 25 },
      { width: 25 },
      { width: 30 },
      { width: 30 },
      { width: 25 },
    ];

    // --- Save and Download Workbook ---
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "TippingFee.xlsx";
    a.click();
    URL.revokeObjectURL(url);
  };




  // Export as PDF
  const downloadPDF = () => {
    const doc = new jsPDF("landscape", "mm", "a4");
    // Centered Title
    doc.text("Tipping Fee", doc.internal.pageSize.getWidth() / 2, 10, { align: "center" });

    // Prepare Table Data
    const tableData = tippingFeeData.map((row, index) => [
      { content: index + 1, styles: { halign: "center" } },
      { content: row.ownerTypeName || "N/A", styles: { halign: "center" } },
      { content: row.collectionTypeName || "N/A", styles: { halign: "center" } },
      { content: row.tippingFeePercentage || "N/A", styles: { halign: "center" } },
      { content: row.perMtinR || "N/A", styles: { halign: "center" } },
      { content: row.effectiveFromDate || "N/A", styles: { halign: "center" } },
      { content: row.previousTippingFee || "N/A", styles: { halign: "center" } },
      { content: row.previousEffectiveFromDate || "N/A", styles: { halign: "center" } },
      { content: row.previousEffectiveToDate || "N/A", styles: { halign: "center" } },
      { content: row.isActive ? "Active" : "InActive", styles: { halign: "center" } }
    ]);

    autoTable(doc, {
      head: [["S.No",
        "Owner Type",
        "Collection Type",
        "Tipping Fee Percentage",
        "Per MT In INR",
        "Effective From Date",
        "Previous Tipping Fee",
        "Effective From Date (Previous)",
        "Effective To Date (Previous)",
        "Status",]],
      body: tableData,
      margin: { top: 20 },
      styles: {
        fontSize: 9, // Further reduced font size for the entire table
      },

      headStyles: { halign: "center", fontStyle: "bold" } // Centers header text
    });

    // Save the PDF
    doc.save("TippingFee.pdf");
  };


  return (
    <>
      {/* PDF Export Button */}
      <button type="button" className="btn btn-excel" onClick={downloadPDF}>
        <i className="fa-solid fa-file-pdf me-1 icon-container"></i> PDF
      </button>

      <button type="reset" className="btn btn-excel" onClick={downloadExcel}>
        <i className="fa-solid fa-file-excel me-1 icon-container"></i> Excel
      </button>
    </>
  );
};
